import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DialogData } from "app/reports/reportdialog";

@Component({
  selector: "app-preop-workup",
  templateUrl: "./preop-workup.component.html",
  styleUrls: ["./preop-workup.component.scss"],
})
export class PreopWorkupComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {}
  closedialog() {
    this.dialog.closeAll();
  }

  preAnesthesiaQuestionnaireModal() {
    document.getElementById("preAnesthesiaQuestionnaire").style.display =
      "block";
  }
  closePreAnesthesiaQuestionnaireModal() {
    document.getElementById("preAnesthesiaQuestionnaire").style.display =
      "none";
  }
}
